export class DropboxError extends Error {
  constructor(message, code) {
    super(message);
    this.name = 'DropboxError';
    this.code = code;
  }
}

export class GoogleDriveError extends Error {
  constructor(message, code) {
    super(message);
    this.name = 'GoogleDriveError';
    this.code = code;
  }
}

export class WhaleSpaceError extends Error {
  constructor(message, code) {
    super(message);
    this.name = 'WhaleSpaceError';
    this.code = code;
  }
}

export class NaverWorksError extends Error {
  constructor(message, code) {
    super(message);
    this.name = 'NaverWorksError';
    this.code = code;
  }
}

export class ActiveLinkApiError extends Error {
  constructor(message, code) {
    super(message);
    this.name = 'ActiveLinkApiError';
    this.code = code;
  }
}
